import React, { useState, useEffect, useCallback } from 'react'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../../config/api'
import axios from 'axios'
import Swal from 'sweetalert2'
import Topbar from '../../mini-comp/Topbar'
import Sidebar from '../../mini-comp/Sidebar'
import {
    RiAddLine,
    RiEdit2Line,
    RiDeleteBinLine,
    RiMoneyDollarCircleLine,
    RiLoader4Line
} from 'react-icons/ri'

const ExchangeRate = () => {
    const [loading, setLoading] = useState(false)
    const [exchangeRates, setExchangeRates] = useState([])
    const [submitting, setSubmitting] = useState(false)

    // Form and Modal State
    const [formData, setFormData] = useState({
        current_rate: '',
        currency: 'ZIG',
        date: new Date().toISOString().split('T')[0]
    })
    const [isEditing, setIsEditing] = useState(false)
    const [editingId, setEditingId] = useState(null)

    const fetchExchangeRates = useCallback(async () => {
        try {
            setLoading(true)
            const token = Cookies.get('token')
            const response = await axios.get(`${API_BASE_URL}/api/v1/billing/exchange-rates/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            setExchangeRates(response.data.exchange_rates)
        } catch (error) {
            console.error('Error fetching exchange rates:', error)
            Swal.fire('Error', 'Failed to fetch exchange rates', 'error')
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchExchangeRates()
    }, [fetchExchangeRates])

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSubmitting(true)

        // Basic validation
        if (!formData.current_rate || parseFloat(formData.current_rate) <= 0) {
            Swal.fire('Error', 'Please enter a valid rate', 'error')
            setSubmitting(false)
            return
        }

        try {
            const token = Cookies.get('token')
            const headers = { 'Authorization': `Bearer ${token}` }

            if (isEditing) {
                await axios.put(`${API_BASE_URL}/api/v1/billing/exchange-rates/${editingId}/`, formData, { headers })
                Swal.fire('Success', 'Exchange rate updated successfully', 'success')
            } else {
                await axios.post(`${API_BASE_URL}/api/v1/billing/exchange-rates/`, formData, { headers })
                Swal.fire('Success', 'Exchange rate added successfully', 'success')
            }

            // Reset form and modal
            setFormData({ current_rate: '', currency: 'ZIG', date: new Date().toISOString().split('T')[0] })
            setIsEditing(false)
            setEditingId(null)
            document.querySelector('#rateModal .btn-close').click()
            fetchExchangeRates()

        } catch (error) {
            console.error('Error saving exchange rate:', error)
            Swal.fire('Error', error.response?.data?.detail || 'Failed to save exchange rate', 'error')
        } finally {
            setSubmitting(false)
        }
    }

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        })

        if (result.isConfirmed) {
            try {
                const token = Cookies.get('token')
                await axios.delete(`${API_BASE_URL}/api/v1/billing/exchange-rates/${id}/`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                })
                Swal.fire('Deleted!', 'Exchange rate has been deleted.', 'success')
                fetchExchangeRates()
            } catch (error) {
                console.error('Error deleting exchange rate:', error)
                Swal.fire('Error', 'Failed to delete exchange rate', 'error')
            }
        }
    }

    const openEditModal = (current_rate) => {
        setFormData({
            current_rate: current_rate.current_rate,
            currency: current_rate.currency || 'ZIG'
        })
        setIsEditing(true)
        setEditingId(current_rate.id)
    }

    const openAddModal = () => {
        setFormData({
            current_rate: '',
            currency: 'ZIG'
        })
        setIsEditing(false)
        setEditingId(null)
    }

    return (
        <div>
            <Topbar />
            <Sidebar />
            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-header justify-between">
                                        <div className="card-title">
                                            Exchange Rates (USD to ZIG)
                                        </div>
                                        <button
                                            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
                                            data-bs-toggle="modal"
                                            data-bs-target="#rateModal"
                                            onClick={openAddModal}
                                        >
                                            <RiAddLine className="fs-5" /> Add New Rate
                                        </button>
                                    </div>
                                    <div className="card-body p-0">
                                        {loading ? (
                                            <div className="d-flex justify-content-center align-items-center py-5">
                                                <RiLoader4Line className="spinner-border text-primary fs-2" role="status" />
                                                <span className="ms-2">Loading rates...</span>
                                            </div>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-hover align-middle mb-0">
                                                    <thead className="bg-light">
                                                        <tr>

                                                            <th>Exchange Rate (1 USD : ZIG)</th>
                                                            <th className="text-end pe-4">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {exchangeRates.length > 0 ? (
                                                            exchangeRates.map((item) => (
                                                                <tr key={item.id}>

                                                                    <td className="fw-bold text-success ps-4">
                                                                        1 : {parseFloat(item.current_rate).toFixed(2)}
                                                                    </td>
                                                                    <td className="text-end pe-4">
                                                                        <div className="d-flex justify-content-end gap-2">
                                                                            <button
                                                                                className="btn btn-sm btn-outline-info d-flex align-items-center gap-1"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#rateModal"
                                                                                onClick={() => openEditModal(item)}
                                                                            >
                                                                                <RiEdit2Line /> Edit
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
                                                                                onClick={() => handleDelete(item.id)}
                                                                            >
                                                                                <RiDeleteBinLine /> Delete
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4" className="text-center py-5 text-muted">
                                                                    <div className="d-flex flex-column align-items-center opacity-75">
                                                                        <RiMoneyDollarCircleLine size={48} className="mb-2" />
                                                                        <p className="mb-0">No exchange rates found</p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* Modal */}
            <div className="modal fade" id="rateModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0 shadow">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title fw-bold">
                                {isEditing ? 'Edit Exchange Rate' : 'Add Exchange Rate'}
                            </h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body p-4">
                                <div className="mb-3">
                                    <label className="form-label fw-bold small text-uppercase">Currency</label>

                                    <input type="text" className="form-control" value="ZIG" disabled readOnly />
                                    <div className="form-text">Exchange rates are fixed to ZIG against 1 USD.</div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-bold small text-uppercase">Rate (ZIG per 1 USD)</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control"
                                        placeholder="Enter rate amount"
                                        value={formData.current_rate}
                                        onChange={(e) => setFormData({ ...formData, current_rate: e.target.value })}
                                        required
                                    />
                                </div>
                                
                            </div>
                            <div className="modal-footer bg-light">
                                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button type="submit" className="btn btn-primary px-4 fw-bold" disabled={submitting}>
                                    {submitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Saving...
                                        </>
                                    ) : (
                                        isEditing ? 'Update Rate' : 'Save Rate'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExchangeRate